import useTranslation from '@space-core/hooks/useTranslation'

import { Box, Subheading, SubheadingDesc, Title } from './communityConfigurationUnbanMemberStyles'

import useCommunityConfigurationSidebar from '../communityConfigurationSidebar/hooks/useConfigurationCommunitySidebar/useCommunityConfigurationSidebar'
import ContainerUnbanMember from '../unbanMemberCommunityModal/components/containerUnbanMember'

const CommunityConfigurationUnbanMember = () => {
  const { t } = useTranslation()
  const { community } = useCommunityConfigurationSidebar()

  return (
    <Box>
      <Title>{t('modal.ban_list.title')}</Title>

      <Subheading>{t('modal.ban_list.sub_title')}</Subheading>

      <SubheadingDesc>{t('modal.ban_list.description')}</SubheadingDesc>

      <div className='_my-5'>
        <ContainerUnbanMember communityId={community.id} fromConfigurationSidebar />
      </div>
    </Box>
  )
}

export default CommunityConfigurationUnbanMember
